<script lang="ts">
  import Router from 'svelte-spa-router';
  import Home from './routes/Home.svelte';
  import Record from './routes/Record.svelte';
  import Settings from './routes/Settings.svelte';
  import SwingDetail from './routes/SwingDetail.svelte';
  import TestVideo from './routes/TestVideo.svelte';

  const routes = {
    '/': Home,
    '/record': Record,
    '/test': TestVideo,
    '/settings': Settings,
    '/swings/:id': SwingDetail,
  };
</script>

<main class="h-full w-full">
  <Router {routes} />
</main>
